import singleton from 'singleton'
import EventEmitter from 'eventemitter3'

const HOST = ''
const API_ENDPOINT = HOST + '/api/v1'

class SostaOnlineApiService extends singleton {
  HOST = HOST;
  token;
  deviceId;
  eventEmitter = new ApiEvents();

  login (username, password) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: username,
          password: password
        })
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.data.token) {
            resolve(response.data)
          } else {
            reject(response)
            this.eventEmitter.emit('auth-error')
          }
        })
        .catch((error) => {
          this.eventEmitter.emit('auth-error')
          reject({message: 'Error on LoginForm', ...error})
        })
    })
  }

  fetchMarkTypesByCategoriesAndArea (categories, area) {
    let categoriesString = ''
    for (let index in categories) {
      categoriesString += categories[index].name
      if (index < categories.length - 1) {
        categoriesString += ','
      }
    }
    return this.baseFetch(API_ENDPOINT + '/markTypes?area=' + area + '&categories=' + categoriesString, 'GET')
  }

  fetchUserLogs (userId) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/logs/user/' + userId, 'GET')
  }

  fetchVehicleLogs (vehicleId) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/logs/vehicle/' + vehicleId, 'GET')
  }

  fetchMarkLogs (markId) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/logs/mark/' + markId, 'GET')
  }

  fetchMarkTypes () {
    return this.baseFetch(API_ENDPOINT + '/markTypes', 'GET')
  }

  fetchPaymentMethods () {
    return this.baseFetch(API_ENDPOINT + '/paymentMethods', 'GET')
  }

  fetchMarkTypesByCategoryAndAreaId (category, areaId) {
    return this.baseFetch(API_ENDPOINT + '/markTypes?areaId=' + areaId + '&category=' + category, 'GET')
  }

  fetchMarkTypesByCategoryAndArea (category, area) {
    return this.baseFetch(API_ENDPOINT + '/markTypes?area=' + area + '&categories=' + category, 'GET')
  }

  fetchMarkTypesByCategoryAndAreaIds (category, areaIds) {
    return this.baseFetch(API_ENDPOINT + '/markTypes?areaIds=' + areaIds + '&categories=' + category, 'GET')
  }

  fetchMyDocuments () {
    return this.baseFetch(API_ENDPOINT + '/documents', 'GET')
  }

  fetchDocumentTypes () {
    return this.baseFetch(API_ENDPOINT + '/markDocumentTypes', 'GET')
  }

  fetchPassReleasedChart (from, to) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/reports/charts/passReleased' + (from && to ? '?startDate=' + from + '&endDate='+ to : ''), 'GET')
  }

  fetchGeneralCounters (from, to) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/reports/counters/general' + (from && to ? '?startDate=' + from + '&endDate='+ to : ''), 'GET')
  }

  fetchOnlineTransactionsCounters (from, to) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/reports/counters/onlineTransactions' + (from && to ? '?startDate=' + from + '&endDate='+ to : ''), 'GET')
  }

  fetchDocumentTypesByMarkTypeId (markTypeId) {
    return this.baseFetch(API_ENDPOINT + '/markDocumentTypes?markType=' + markTypeId, 'GET')
  }

  fetchPublicSettings () {
    return this.baseFetch(API_ENDPOINT + '/settings', 'GET')
  }

  fetchMyOrdersHistory () {
    return this.baseFetch(API_ENDPOINT + '/orders', 'GET')
  }

  fetchMarkRulesByCategoryAndAreaIdAndMark (category, areaId, mark) {
    return this.baseFetch(API_ENDPOINT + '/markRules?areaId=' + areaId + '&category=' + category + '&mark=' + mark, 'GET')
  }

  fetchParkTicketTypes () {
    return this.baseFetch(API_ENDPOINT + '/parkTicketTypes', 'GET')
  }

  fetchParkTicketType (id) {
    return this.baseFetch(API_ENDPOINT + '/parkTicketTypes/' + id, 'GET')
  }

  fetchUser (userId) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/users/' + userId, 'GET')
  }

  fetchRegistry (fiscalCode) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/registries/' + fiscalCode, 'GET')
  }

  fetchUsersWaitingList (filterObj, limit, offset) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/users/waiting-list?limit=' + limit + '&offset=' + offset + '&' + filterObj, 'GET')
  }

  fetchUserMe () {
    return this.baseFetch(API_ENDPOINT + '/users/me', 'GET')
  }

  fetchUserTypes () {
    return this.baseFetch(API_ENDPOINT + '/userTypes', 'GET')
  }

  fetchUserCategories () {
    return this.baseFetch(API_ENDPOINT + '/categories', 'GET')
  }

  fetchUserCategoryById (id) {
    return this.baseFetch(API_ENDPOINT + '/categories/' + id, 'GET')
  }

  fetchUserType (id) {
    return this.baseFetch(API_ENDPOINT + '/userTypes/' + id, 'GET')
  }

  fetchAddresses () {
    return this.baseFetch(API_ENDPOINT + '/addresses', 'GET')
  }

  fetchAreas () {
    return this.baseFetch(API_ENDPOINT + '/areas', 'GET')
  }

  fetchMarks (filterObj, limit, offset) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/marks?limit=' + limit + '&offset=' + offset + '&' + filterObj, 'GET')
  }

  fetchMarksByUserId (id) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/marks?column=userId&value=' + id, 'GET')
  }

  fetchUsers (filterObj, limit, offset) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/users?limit=' + limit + '&offset=' + offset + '&' + filterObj, 'GET')
  }

  fetchVehicles (filterObj, limit, offset) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/vehicles?limit=' + limit + '&offset=' + offset + '&' + filterObj, 'GET')
  }

  fetchVehiclesByUserId (userId) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/vehicles', 'GET')
  }

  fetchVehicleOwnershipTypes () {
    return this.baseFetch(API_ENDPOINT + '/vehicleOwnershipTypes', 'GET')
  }

  fetchVehiclePowerSupplies () {
    return this.baseFetch(API_ENDPOINT + '/vehiclePowerSupplies', 'GET')
  }

  fetchParkingPasses () {
    return this.baseFetch(API_ENDPOINT + '/parkingPasses', 'GET')
  }

  fetchParkingPassTypes () {
    return this.baseFetch(API_ENDPOINT + '/parkingPassTypes', 'GET')
  }

  fetchReceipts (filterObj, limit, offset) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/receipts?limit=' + limit + '&offset=' + offset + '&' + filterObj, 'GET')
  }

  fetchCart () {
    return this.baseFetch(API_ENDPOINT + '/cart', 'GET')
  }

  countUser () {
    return this.baseFetch(API_ENDPOINT + '/users/all/all', 'GET')
  }

  deleteUser (id) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/users/' + id, 'DELETE')
  }

  deleteWaitingList (id) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingLists/' + id, 'DELETE')
  }

  rejectUserFromWaitingList (waitingListSubscriptionId) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingListSubscriptions/' + waitingListSubscriptionId + '/reject', 'PUT')
  }

  fetchThingsToDo () {
    return this.baseFetch(API_ENDPOINT + '/backoffice/report', 'GET')
  }

  fetchWaitingLists (filterObj, limit, offset) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingLists?limit=' + limit + '&offset=' + offset + '&' + filterObj, 'GET')
  }

  fetchWaitingListSubscriptions (filterObj, limit, offset) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingListSubscriptions?limit=' + limit + '&offset=' + offset + '&' + filterObj, 'GET')
  }

  fetchUserWaitingListsSubribable () {
    return this.baseFetch(API_ENDPOINT + '/waitingLists', 'GET')
  }

  fetchUserWaitingLists () {
    return this.baseFetch(API_ENDPOINT + '/waitingLists', 'GET')
  }

  fetchUserWaitingListSubscriptionsCount () {
    return this.baseFetch(API_ENDPOINT + '/waitingListSubscriptions/activeSubscriptions', 'GET')
  }

  fetchUserWaitingList (id) {
    return this.baseFetch(API_ENDPOINT + '/waitingLists/' + id, 'GET')
  }

  fetchUserMyPartecipationWaitingLists () {
    return this.baseFetch(API_ENDPOINT + '/waitingLists/myPartecipations', 'GET')
  }

  fetchBackofficeMyPartecipationWaitingLists (userId) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingLists/' + userId + '/participation', 'GET')
  }

  fetchWaitingList (id) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingLists/' + id, 'GET')
  }

  createWaitingList (waitingList) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingLists', 'POST', JSON.stringify(waitingList))
  }

  updateWaitingList (waitingList) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingLists/' + waitingList.id, 'PUT', JSON.stringify(waitingList))
  }

  updateUser (user) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/users/' + user.id, 'PUT', JSON.stringify({
      // username: user.email,
      email: user.email,
      phone: user.phone,
      // password: user.password,
      firstName: user.firstName,
      lastName: user.lastName,

      residenceCity: user.residenceCity,
      residenceAddress: user.residenceAddress,
      residenceCivicNumber: user.residenceCivicNumber,
      residenceCap: user.residenceCap,
      birthPlace: user.birthPlace,
      birthDate: user.birthDate,
      sex: user.sex,

      secondaryResidenceCity: user.secondaryResidenceCity,
      secondaryResidenceAddress: user.secondaryResidenceAddress,
      secondaryResidenceCap: user.secondaryResidenceCap,

      workCity: user.workCity,
      workAddress: user.workAddress,
      workCap: user.workCap,
      workCivicNumber: user.workCivicNumber,
      fiscalCode: user.fiscalCode,
      companyName: user.companyName,
      companyLegalAddress: user.companyLegalAddress,
      vatNumber: user.vatNumber,
      userCategories: user.userCategories,
      workAreaId: parseInt(user.workAreaId),
      residenceAreaId: parseInt(user.residenceAreaId),
      parkSpaceAddressId: user.parkSpaceAddressId
    }))
  }

  generateUserCredentials (userId, password) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/users/' + userId + '/generateCredentials', 'PUT', JSON.stringify({
      password: password
    }))
  }

  findUser (column, value) {
    return this.baseFetch(API_ENDPOINT + '/users?column=' + column + '&offset=' + value, 'GET')
  }

  downloadMark (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/backoffice/downloads/marks/' + id, {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download mark: ', ...error})
      })
    })
  }

  downloadMarkMe (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/downloads/marks/' + id, {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download mark: ', ...error})
      })
    })
  }

  downloadMarkRelease (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/backoffice/downloads/marks/' + id + '/release', {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download mark release: ', ...error})
      })
    })
  }

  downloadMarkReleaseMe (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/downloads/marks/' + id + '/release', {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download mark release: ', ...error})
      })
    })
  }

  downloadParkTicketMe (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/downloads/parkTickets/' + id, {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download parkTicket: ', ...error})
      })
    })
  }

  downloadParkTicket (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/backoffice/downloads/parkTickets/' + id, {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download park-ticket: ', ...error})
      })
    })
  }

  downloadDocument (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/backoffice/downloads/documents/' + id, {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download document: ', ...error})
      })
    })
  }

  downloadUserCredentials (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/backoffice/downloads/user-credentials-' + id, {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download user-credentials: ', ...error})
      })
    })
  }

  downloadAdjustmentReceipt (id) {
    // return this.baseFetch(API_ENDPOINT + '/backoffice/downloads/adjustments/' + id + '/receipt', 'GET')
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/backoffice/downloads/adjustments/' + id + '/receipt', {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download receipt: ', ...error})
      })
    })
  }

  downloadReceipt (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/backoffice/downloads/parkTickets/' + id + '/receipt', {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download receipt: ', ...error})
      })
    })
  }

  downloadMarkReceiptMe (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/downloads/marks/' + id + '/receipt', {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download mark receipt: ', ...error})
      })
    })
  }

  downloadAdjustmentReceiptMe (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/downloads/adjustments/' + id + '/receipt', {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download adjustment receipt: ', ...error})
      })
    })
  }

  downloadMarkReceipt (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/backoffice/downloads/marks/' + id + '/receipt', {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download mark receipt: ', ...error})
      })
    })
  }

  downloadReceiptMe (id) {
    return new Promise((resolve, reject) => {
      fetch(API_ENDPOINT + '/downloads/parkTickets/' + id + '/receipt', {
        method: 'GET',
        headers: this.getHeaders()
      }).then((response) => {
        return response.blob()
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject({message: 'Error on download parkTicket: ', ...error})
      })
    })
  }

  createUser (user) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/users', 'POST', JSON.stringify({
      username: user.email,
      email: user.email,
      phone: user.phone,
      password: user.password,
      firstName: user.firstName,
      lastName: user.lastName,

      residenceCity: user.residenceCity,
      residenceAddress: user.residenceAddress,
      residenceCivicNumber: user.residenceCivicNumber,
      residenceCap: user.residenceCap,
      birthPlace: user.birthPlace,
      birthDate: user.birthDate,
      sex: user.sex,

      secondaryResidenceCity: user.secondaryResidenceCity,
      secondaryResidenceAddress: user.secondaryResidenceAddress,
      secondaryResidenceCap: user.secondaryResidenceCap,

      workCity: user.workCity,
      workAddress: user.workAddress,
      workCap: user.workCap,
      workCivicNumber: user.workCivicNumber,
      fiscalCode: user.fiscalCode,
      companyName: user.companyName,
      companyLegalAddress: user.companyLegalAddress,
      vatNumber: user.vatNumber,
      userCategories: user.userCategories,
      workAreaId: user.workAreaId,
      residenceAreaId: user.residenceAreaId,
      parkSpaceAddressId: user.parkSpaceAddress,
      parkSpaceAddressIds: user.parkSpaceAddresses
    }))
  }

  createMark (mark) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/marks', 'POST', JSON.stringify(mark))
  }

  addMarkNote (note) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/markNotes', 'POST', JSON.stringify({
      ...note
    }))
  }

  updateMark (mark) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/marks/' + mark.id, 'PUT', JSON.stringify({
      issuedDate: mark.issuedDate,
      startDate: mark.startDate,
      endDate: mark.endDate,
      active: mark.active,
      userId: mark.userId,
      note: mark.note,
      areaId: mark.areaId,
      firstVehicleId: mark.firstVehicleId,
      secondVehicleId: mark.secondVehicleId,
      markTypeId: mark.markTypeId,
      categoryId: mark.categoryId,
      ceased: mark.ceased,
      action: mark.action,
      circolazione: mark.circolazione,
      periodo: mark.periodo,
      sosta: mark.sosta
    }))
  }

  updateMarkMe (mark) {
    return this.baseFetch(API_ENDPOINT + '/marks/' + mark.id, 'PUT', JSON.stringify({
      vehicles: mark.vehicles,
      documents: mark.documents
    }))
  }

  renewMark (mark) {
    return this.baseFetch(API_ENDPOINT + '/marks/' + mark.id, 'PUT', JSON.stringify({
      action: 'RENEW',
      vehicles: mark.Vehicles,
      markTypeId: mark.MarkTypeId,
      categoryId: mark.categoryId,
      startAddressId: mark.startAddressId,
      documents: mark.documents
    }))
  }

  createMarkMe (mark) {
    return this.baseFetch(API_ENDPOINT + '/marks', 'POST', JSON.stringify({
      vehicles: mark.vehicles,
      markTypeId: mark.markTypeId,
      categoryId: mark.categoryId,
      startAddressId: mark.startAddressId,
      documents: mark.documents
    }))
  }

  subscribeToWaitingList (waitingListId, vehicles) {
    return this.baseFetch(API_ENDPOINT + '/waitingListSubscriptions', 'POST', JSON.stringify({
      vehicles: vehicles,
      waitingListId: waitingListId
    }))
  }

  closeWaitingList (waitingListId) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingLists/' + waitingListId + '/close', 'PUT')
  }

  sendOpenMailToAllWaitingListUsers (waitingListId) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingLists/' + waitingListId + '/sendMail', 'PUT')
  }

  getBase64 (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }

  async createDocuments (data) {
    const req = []
    for (let doc of data.documents) {
      if(doc.document) {
        let encDoc = await this.getBase64(doc.document)
        req.push({
          document: encDoc,
          documentTypeId: doc.documentTypeId,
          vehiclePlateNumber: doc.vehiclePlateNumber,
          type: doc.document.type,
          markId: data.markId
        })
      }
    }
    // return this.baseFetch(API_ENDPOINT + '/documents', 'POST', JSON.stringify(req))
  }

  uploadDocument (name, typeId, file) {
    return new Promise((resolve, reject) => {
      const data = new FormData()
      data.append('file', file)
      data.append('name', name)
      data.append('typeId', typeId)
      fetch(API_ENDPOINT + '/documents', {
        method: 'POST',
        headers: {'Authorization': 'Bearer ' + this.token},
        body: data
      }).then((response) => {
        switch (response.status) {
          case 401:
            this.eventEmitter.emit('auth-error')
            reject({status: 401, message: 'Auth Error', ...response})
            return null
          default:
            return response.json()
        }
      }).then((response) => {
        if (response.result === 'ko') {
          reject(response)
        } else {
          resolve(response)
        }
      }).catch((error) => {
        reject({message: 'Error uploading document', ...error})
      })
    })
  }

  updateMarkDocumentApprovation (documentId, markId, approved) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/documents/' + documentId + '/marks/' + markId, 'PUT', JSON.stringify({
      approved: !!approved
    }))
  }

  updateVehicleDocumentApprovation (documentId, vehicleId, approved) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/documents/' + documentId + '/vehicles/' + vehicleId, 'PUT', JSON.stringify({
      approved: !!approved
    }))
  }

  createVehicle (vehicle) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/vehicles', 'POST', JSON.stringify({
      userId: vehicle.userId,
      plateNumber: vehicle.plateNumber,
      type: vehicle.type,
      powerSupply: vehicle.powerSupply
    }))
  }

  createCartItem (cartItem) {
    return this.baseFetch(API_ENDPOINT + '/cart', 'POST', JSON.stringify(cartItem))
  }

  updateCartItem (cartItem) {
    return this.baseFetch(API_ENDPOINT + '/cart/' + cartItem.id, 'PUT', JSON.stringify(cartItem))
  }

  fetchMarkRulesByCategoryAndAreaAndMark (category, areaId, markType) {
    return this.baseFetch(API_ENDPOINT + '/markRules?areaId=' + areaId + '&category=' + category + '&markType=' + markType, 'GET')
  }

  fetchMarkRulesByMarkType (markType) {
    return this.baseFetch(API_ENDPOINT + '/markRules?markType=' + markType, 'GET')
  }

  fetchMarkPrice (userId, markType, category, vehicles, vehiclePowerSupplies) {
    return this.baseFetch(API_ENDPOINT + '/markPrices?userId=' + userId + '&categoryId=' + category + (!!vehicles && !vehiclePowerSupplies ? ('&vehicleIds=' + vehicles) : ('&vehiclePowerSupplyIds=' + vehiclePowerSupplies)) + '&markTypeId=' + markType, 'GET')
  }

  fetchMarkMe (markId) {
    return this.baseFetch(API_ENDPOINT + '/marks/' + markId, 'GET')
  }

  fetchSetting (name) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/settings/' + name, 'GET')
  }

  fetchSettings () {
    return this.baseFetch(API_ENDPOINT + '/backoffice/settings', 'GET')
  }

  updateSetting (name, value) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/settings/' + name, 'POST', JSON.stringify({
      value: value
    }))
  }

  createVehicleMe (vehicle) {
    return this.baseFetch(API_ENDPOINT + '/vehicles', 'POST', JSON.stringify({
      plateNumber: vehicle.plateNumber,
      type: vehicle.type
    }))
  }

  updateVehicle (vehicle) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/vehicles/' + vehicle.id, 'PUT', JSON.stringify({
      plateNumber: vehicle.plateNumber,
      type: vehicle.type,
      powerSupply: vehicle.powerSupply
    }))
  }

  deleteVehicle (vehicle) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/vehicles/' + vehicle.id, 'DELETE')
  }

  deleteMark (mark) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/marks/' + mark.id, 'DELETE')
  }

  deleteCartItem (cartItem) {
    return this.baseFetch(API_ENDPOINT + '/cart/' + cartItem.id, 'DELETE')
  }

  editMarkBackoffice (mark) {
    return this.baseFetch(
      API_ENDPOINT + '/backoffice/marks/' + mark.id + '?ceaseAndCreate=1',
      'PUT',
      JSON.stringify(mark)
    )
  }

  ceaseMark (mark) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/marks/' + mark.id, 'PUT', JSON.stringify({
      ceased: true
    }))
  }

  createParkTicket (parkTicket) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/parkTickets', 'POST', JSON.stringify({
      issuedDate: parkTicket.issuedDate,
      quantity: parkTicket.quantity,
      method: parkTicket.method,
      startDate: parkTicket.startDate,
      endDate: parkTicket.endDate,
      active: parkTicket.active,
      userId: parkTicket.userId,
      markId: parkTicket.markId,
      areaId: parkTicket.areaId,
      vehicleId: parkTicket.vehicleId,
      parkTicketTypeId: parkTicket.parkTicketTypeId,
      categoryId: parkTicket.categoryId,
      total: parkTicket.total,
      vehicles: parkTicket.vehicles,
      note: parkTicket.note,
      circolazione: parkTicket.circolazione,
      periodo: parkTicket.periodo,
      sosta: parkTicket.sosta,
      color: parkTicket.color,
    }))
  }

  createReceipt (receipt) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/receipts', 'POST', JSON.stringify({
      parkTicketId: receipt.parkTicketId,
      method: receipt.method,
      total: receipt.total
    }))
  }

  residentRegistration (data) {
    return this.baseFetch(API_ENDPOINT + '/registration', 'POST', JSON.stringify({
      email: data.email,
      username: data.email,
      password: data.password,
      firstname: data.firstName,
      lastname: data.lastName,
      phone: data.phone,
      role: 'user',
      typeuserid: data.userTypeId,
      parkingtype: data.parkingPassType,
      vehicletype: data.vehicleType,
      birthdate: data.birthDate,
      nameArea: data.areaCode,
      start_date: data.startDate,
      end_date: data.endDate,
      codicefiscale: data.fiscalCode,
      plates_number: [data.plateNumber],
      selfcertification: data.selfCertifications
    }))
  }

  register (user) {
    return this.baseFetch(API_ENDPOINT + '/register', 'POST', JSON.stringify({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phone: user.phone,
      password: user.password,
      repeatedPassword: user.repeatedPassword,
      fiscalCode: user.fiscalCode,

      residenceCity: user.residenceCity,
      residenceAddress: user.residenceAddress,
      residenceCivicNumber: user.residenceCivicNumber,
      birthPlace: user.birthPlace,
      birthDate: user.birthDate,
      sex: user.sex,

      secondaryResidenceCity: user.secondaryResidenceCity,
      secondaryResidenceAddress: user.secondaryResidenceAddress,
      secondaryResidenceCap: user.secondaryResidenceCap,
      companyLegalAddress: user.workAddress,

      workCity: user.workCity,
      workAddress: user.workAddress,
      workCivicNumber: user.workCivicNumber,
      workCap: user.workCap,
      companyName: user.companyName,
      vatNumber: user.vatNumber,
      workAreaId: user.workAreaId,
      residenceAreaId: user.residenceAreaId,

      userCategories: user.userCategories,
      vehicles: user.vehicles,
      markTypeId: user.markTypeId,

      marksLimitConsent: user.marksLimitConsent,
      privatePlaceReductionConsent: user.privatePlaceReductionConsent,
      overLimitConsent: user.overLimitConsent,
      employeesThreeMonthsConsent: user.employeesThreeMonthsConsent,
      parkSpaceAddressId: user.parkingSpaceAddress
    }))
  }

  buyParkingTickets (parkingTickets) {
    return this.baseFetch(API_ENDPOINT + '/payment/buy', 'POST', JSON.stringify({}))
  }

  buyWaitingListParkTicket (waitingListId) {
    return this.baseFetch(API_ENDPOINT + '/payment/buyWaitingListParkTicket/' + waitingListId, 'POST', JSON.stringify({}))
  }

  buyAdjustment (adjustmentId) {
    return this.baseFetch(API_ENDPOINT + '/payment/buyAdjustment/' + adjustmentId, 'POST', JSON.stringify({}))
  }

  buyMark (markId) {
    return this.baseFetch(API_ENDPOINT + '/payment/buyMark/' + markId, 'POST', JSON.stringify({}))
  }

  fetchAdjustment (fiscalCode = '', vat = '') {
    return this.baseFetch(API_ENDPOINT + '/backoffice/adjustments?fiscalCode=' + fiscalCode + '&vat=' + vat, 'GET')
  }

  fetchAdjustmentMe () {
    return this.baseFetch(API_ENDPOINT + '/adjustments', 'GET')
  }

  fetchMergerMe () {
    return this.baseFetch(API_ENDPOINT + '/merger', 'GET')
  }

  acceptUserMerge () {
    return this.baseFetch(API_ENDPOINT + '/merger/accept', 'GET')
  }

  denyUserMerge () {
    return this.baseFetch(API_ENDPOINT + '/merger/deny', 'GET')
  }

  fetchMerge (fiscalCode = '') {
    return this.baseFetch(API_ENDPOINT + '/backoffice/merger?fiscalCode=' + fiscalCode, 'GET')
  }

  acceptMerge (fiscalCode = '') {
    return this.baseFetch(API_ENDPOINT + '/backoffice/merger/accept?fiscalCode=' + fiscalCode, 'GET')
  }

  denyMerge (fiscalCode = '') {
    return this.baseFetch(API_ENDPOINT + '/backoffice/merger/deny?fiscalCode=' + fiscalCode, 'GET')
  }

  setAdjustmentPayed (adjustmentId, userId, method) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/adjustments/' + adjustmentId, 'POST', JSON.stringify({
      userId,
      method
    }))
  }

  approveWaitingListSubscriptionParkTicket (waitingListSubscriptionId, userId, paymentMethod) {
    return this.baseFetch(API_ENDPOINT + '/backoffice/waitingListSubscriptions/' + waitingListSubscriptionId + '/approve', 'PUT', JSON.stringify({
      userId,
      paymentMethod
    }))
  }

  decryptOperationResult (a, b) {
    return this.baseFetch(API_ENDPOINT + '/payment/result?a=' + a + '&b=' + b, 'GET')
  }

  changePasswordMe (obj) {
    return this.baseFetch(API_ENDPOINT + '/passwordRecovery/changePassword', 'POST', JSON.stringify({
      key: obj.key,
      userId: obj.userId,
      password: obj.password,
      repeatedPassword: obj.repeatedPassword
    }))
  }

  sendMailChangePasswordMe (obj) {
    return this.baseFetch(API_ENDPOINT + '/passwordRecovery/sendEmail', 'POST', JSON.stringify({
      email: obj.email
    }))
  }

  confirmMail (userId, key) {
    return this.baseFetch(API_ENDPOINT + '/confirmEmail?key=' + key + '&userId=' + userId, 'POST', JSON.stringify({
      key: key,
      userId: userId
    }))
  }

  baseFetch (url, method, body = null, headers = null) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: method,
        headers: headers ? this.getHeaders(headers) : this.getHeaders(),
        body: body
      }).then((response) => {
        switch (response.status) {
          case 401:
            this.eventEmitter.emit('auth-error')
            reject({status: 401, message: 'Auth Error', ...response})
            return null
          default:
            return response.json()
        }
      }).then((response) => {
        if (response.result === 'ko') {
          reject(response)
        } else {
          resolve(response)
        }
      }).catch((error) => {
        reject({message: 'Error on baseFetch at url: ' + url, ...error})
      })
    })
  }

  getHeaders (options = {contentType: 'application/json'}) {
    let opts = {
      contentType: options.contentType || 'application/json'
    }

    let headers = {}

    if (opts.contentType) {
      headers['Content-Type'] = opts.contentType
    }

    if (this.token) {
      headers['Authorization'] = 'Bearer ' + this.token
    }

    return headers
  };

  setToken (token) {
    this.token = token
  }

  setDeviceId (deviceId) {
    this.deviceId = deviceId
  }

  clearToken () {
    this.token = null
  }
}

class ApiEvents extends EventEmitter {}

export default new SostaOnlineApiService()



// WEBPACK FOOTER //
// ./src/services/SostaOnlineApiService.js